// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services-container {
    text-align: center;
    padding: 40px;
    margin-top: 80px;
  }
  
  .title {
    font-size: 48px;
    font-weight: 700;
    color: #212529; /* Dark gray color */
    font-family: "Plus Jakarta Sans", sans-serif;
  }
  
  .subtitle {
    font-size: 22px;
    font-weight: 500;
    color: #6C757D; /* Dark gray color */
    font-family: "Plus Jakarta Sans", sans-serif;
    margin-bottom: 64px;
  }
  
  .services-grid {
    gap: 20px;
    justify-content: center;
    flex-direction: column;
    margin-left: 100px;
    margin-right: 100px;
  }
  
  .service-card {
    background: #F8F9FA;
    padding: 32px;
    border-radius: 10px;
    text-align: left;
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .service-page-card-description {
    font-size: 22px;
    font-weight: 400;
    color: #6C757D;
    text-align: left;
    align-self: flex-start; /* Works inside a flex container */
    font-family: "Plus Jakarta Sans", serif;
    max-width: 80rem;
    margin-top: 24px;
  }

  .service-page-card-title {
    font-size: 28px;
    font-weight: 700;
    color: #212529;
    text-align: left;
    align-self: flex-start; /* Works inside a flex container */
    font-family: "Plus Jakarta Sans", serif;
    max-width: 80rem;
    margin-top: 24px;
  }
  
  .section-title {
    font-size: 18px;
    font-weight: bold;
    margin-top: 15px;
  }
  
  .contact-btn-style {
    background: #008c4a;
    color: white;
    padding: 10px 38px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 10px;
  }
  
  .contact-btn-style:hover {
    background: #006b38;
  }

  .service-page-heading-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 32px;
    margin-bottom: 22px;
}

.service-page-green-line {
    width: 30px; /* Adjust width */
    height: 5px; /* Adjust thickness */
    background-color: #008D62; /* Green color */
    border-radius: 5px; /* Rounded edges */
}

.service-page-heading-text {
    font-size: 20px;
    font-weight: 600;
    color: #4A4A4A; /* Dark gray color */
    font-family: "Plus Jakarta Sans", sans-serif;
}

.service-light-list-text-style {
    font-size: 16px;
    font-weight: 500;
    color: #6C757D; /* Dark gray color */
    font-family: "Plus Jakarta Sans", sans-serif;
    margin-left: 30px;
}

.service-page-gray-text-style {
    font-size: 22px;
    font-weight: 700;
    color: #212529; /* Dark gray color */
    font-family: "Plus Jakarta Sans", sans-serif;
    margin-left: 10px;
}

.connect-btn-text-style {
    font-size: 16px;
    font-weight: 700;
    color: #FFFFFF; /* Dark gray color */
    font-family: "Plus Jakarta Sans", sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/pages/Services/service.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAE,oBAAoB;IACpC,4CAA4C;EAC9C;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAE,oBAAoB;IACpC,4CAA4C;IAC5C,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;IACrB,wCAAwC;EAC1C;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,sBAAsB,EAAE,kCAAkC;IAC1D,uCAAuC;IACvC,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,sBAAsB,EAAE,kCAAkC;IAC1D,uCAAuC;IACvC,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW,EAAE,iBAAiB;IAC9B,WAAW,EAAE,qBAAqB;IAClC,yBAAyB,EAAE,gBAAgB;IAC3C,kBAAkB,EAAE,kBAAkB;AAC1C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAE,oBAAoB;IACpC,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAE,oBAAoB;IACpC,4CAA4C;IAC5C,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAE,oBAAoB;IACpC,4CAA4C;IAC5C,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAE,oBAAoB;IACpC,4CAA4C;AAChD","sourcesContent":[".services-container {\n    text-align: center;\n    padding: 40px;\n    margin-top: 80px;\n  }\n  \n  .title {\n    font-size: 48px;\n    font-weight: 700;\n    color: #212529; /* Dark gray color */\n    font-family: \"Plus Jakarta Sans\", sans-serif;\n  }\n  \n  .subtitle {\n    font-size: 22px;\n    font-weight: 500;\n    color: #6C757D; /* Dark gray color */\n    font-family: \"Plus Jakarta Sans\", sans-serif;\n    margin-bottom: 64px;\n  }\n  \n  .services-grid {\n    gap: 20px;\n    justify-content: center;\n    flex-direction: column;\n    margin-left: 100px;\n    margin-right: 100px;\n  }\n  \n  .service-card {\n    background: #F8F9FA;\n    padding: 32px;\n    border-radius: 10px;\n    text-align: left;\n    margin-bottom: 20px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-end;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  }\n\n  .service-page-card-description {\n    font-size: 22px;\n    font-weight: 400;\n    color: #6C757D;\n    text-align: left;\n    align-self: flex-start; /* Works inside a flex container */\n    font-family: \"Plus Jakarta Sans\", serif;\n    max-width: 80rem;\n    margin-top: 24px;\n  }\n\n  .service-page-card-title {\n    font-size: 28px;\n    font-weight: 700;\n    color: #212529;\n    text-align: left;\n    align-self: flex-start; /* Works inside a flex container */\n    font-family: \"Plus Jakarta Sans\", serif;\n    max-width: 80rem;\n    margin-top: 24px;\n  }\n  \n  .section-title {\n    font-size: 18px;\n    font-weight: bold;\n    margin-top: 15px;\n  }\n  \n  .contact-btn-style {\n    background: #008c4a;\n    color: white;\n    padding: 10px 38px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-top: 10px;\n  }\n  \n  .contact-btn-style:hover {\n    background: #006b38;\n  }\n\n  .service-page-heading-container {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-top: 32px;\n    margin-bottom: 22px;\n}\n\n.service-page-green-line {\n    width: 30px; /* Adjust width */\n    height: 5px; /* Adjust thickness */\n    background-color: #008D62; /* Green color */\n    border-radius: 5px; /* Rounded edges */\n}\n\n.service-page-heading-text {\n    font-size: 20px;\n    font-weight: 600;\n    color: #4A4A4A; /* Dark gray color */\n    font-family: \"Plus Jakarta Sans\", sans-serif;\n}\n\n.service-light-list-text-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: #6C757D; /* Dark gray color */\n    font-family: \"Plus Jakarta Sans\", sans-serif;\n    margin-left: 30px;\n}\n\n.service-page-gray-text-style {\n    font-size: 22px;\n    font-weight: 700;\n    color: #212529; /* Dark gray color */\n    font-family: \"Plus Jakarta Sans\", sans-serif;\n    margin-left: 10px;\n}\n\n.connect-btn-text-style {\n    font-size: 16px;\n    font-weight: 700;\n    color: #FFFFFF; /* Dark gray color */\n    font-family: \"Plus Jakarta Sans\", sans-serif;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
